import { SxProps } from '@mui/material';

export const styledBenefitItem: SxProps = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
};

export const styledBenefitSectionWrapper: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
};
